import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import BoltIcon from '@mui/icons-material/Bolt';

const KPICards = ({ data }) => {
  const theme = useTheme();
  
  if (!data) return null;
  
  const kpis = [
    {
      title: 'Total Revenue',
      value: data.totalRevenue,
      icon: <AttachMoneyIcon fontSize="large" />,
      format: value => `$${value.toLocaleString()}`,
      color: theme.palette.primary.main
    },
    {
      title: 'Total Profit',
      value: data.totalProfit,
      icon: <EqualizerIcon fontSize="large" />,
      format: value => `$${value.toLocaleString()}`,
      change: data.profitChange,
      color: theme.palette.secondary.main
    },
    {
      title: 'Energy Production',
      value: data.energyProduction,
      icon: <BoltIcon fontSize="large" />,
      format: value => `${(value / 1000000).toFixed(2)}M kWh`,
      color: theme.palette.energy.solar
    }
  ];

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      {kpis.map((kpi, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card elevation={2} sx={{ height: '100%' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                <Typography variant="h6" component="div" color="text.secondary">
                  {kpi.title}
                </Typography>
                <Box sx={{ color: kpi.color }}>
                  {kpi.icon}
                </Box>
              </Box>
              
              <Typography variant="h4" component="div" sx={{ fontWeight: 500 }}>
                {kpi.format(kpi.value)}
              </Typography>
              
              {kpi.change !== undefined && (
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  mt: 1,
                  color: kpi.change >= 0 ? 'success.main' : 'error.main'
                }}>
                  {kpi.change >= 0 ? <TrendingUpIcon /> : <TrendingDownIcon />}
                  <Typography variant="body2" component="span" sx={{ ml: 0.5 }}>
                    {Math.abs(kpi.change).toFixed(1)}% {kpi.change >= 0 ? 'increase' : 'decrease'}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default KPICards;
